import React from 'react'
import { MapContext } from './MapContext'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('../assets/marker.svg'),
  iconUrl: require('../assets/marker.svg'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

class Map extends React.Component {
  constructor(props) {
    super(props)

    this.defaults = {
      crs: L.CRS.Simple,
      attributionControl: false,
      maxZoom: 1,
      minZoom: -2,
      zoomDelta: 0.5,
      zoomSnap: 0,
      zoomControl: false,
      center: [0, 0],
      zoom: -2,
      maxBounds: null,
      maxBoundsViscosity: 1,
      wheelPxPerZoomLevel: 100,
    }

    this.options = {
      ...this.defaults,
      ...this.props.options,
    }
  }

  componentDidMount() {
    this.map = L.map(this.el, this.options)
    this.contextValue = this.map

    L.control.zoom({ position: 'bottomright' }).addTo(this.map)

    this.forceUpdate()
    this.props.getMap(this.map)

    this.map.on('click', this.handleMapClick)
    window.addEventListener('resize', this.handleMapResize, false)
  }

  componentWillUnmount() {
    this.map.off('click', this.handleMapClick)
    window.removeEventListener('resize', this.handleMapResize, false)

    this.map.remove()
  }

  handleMapClick = e => {
    console.log('---------------------------')
    console.log('Current view')
    console.log(`[${Math.round(this.map.getCenter().lat)},${Math.round(this.map.getCenter().lng)}]`, this.map.getZoom())
    console.log('-------------------')
    console.log('Mouse position')
    console.log(`[${Math.round(e.latlng.lat)},${Math.round(e.latlng.lng)}]`)
  }

  handleMapResize = e => {
    this.map.invalidateSize(true)
  }

  render() {
    const mapHeight = this.props.height ? `${this.props.height}px` : '69.4rem'

    return (
      <div ref={el => this.el = el} style={{ height: mapHeight }}>
        {this.contextValue ? (
          <MapContext.Provider value={this.contextValue}>
            {this.props.children}
          </MapContext.Provider>
        ) : null}
      </div>
    )
  }
}

export default Map



// WEBPACK FOOTER //
// ./src/components/library/widgets/map/components/Map.js